import getPeriodRange from 'core/controllerPlansFixed/utils/getPeriodRange'
import textContent from 'utils/DOM/textContent'

function showEndDate(selector, filters, durations, showMonthDate = false) {
  if (!showMonthDate) {
    textContent(selector, durations[filters.period][filters.policies].monthly.endDate)
  } else {
    textContent(
      selector,
      getPeriodRange(durations[filters.period][filters.policies].monthly.endDate)
        .monthName.start
    )
  }
}
export default showEndDate
